import Breadcrumbs from "@storeblocks/breadcrumbs";
import { ROUTER_PATH } from "../../router/paths";
import React from "react";
import { useLocation } from "react-router";

interface Props {
  basename: string;
}

const Breadcrumb: React.FC<Props> = ({ basename }) => {
  const location = useLocation();

  const createAppBreadcrumbs = () => {
    const crumbs = [];

    if (location && location.pathname) {
      const { pathname } = location;

      if (pathname !== ROUTER_PATH.ROOT) {
        crumbs.push({
          href: `/${basename}`,
          title: "Dine helseskjema",
        });
      }
    }
    return crumbs;
  };

  return <Breadcrumbs crumbs={createAppBreadcrumbs()} />;
};

export default Breadcrumb;
